import types from 'actions/types'

export const selectContact = (contactId, companyId) => ({type: types.NAVIGATION_SELECT_CONTACT, contactId, companyId})

export const selectCompany = (companyId) => ({type: types.NAVIGATION_SELECT_COMPANY, companyId})

export const selectContactForCompany = (companyId) => ({type: types.NAVIGATION_SELECT_CONTACT_FOR_COMPANY, companyId})

export const selectTab = (tab, id = null) => ({type: types.NAVIGATION_SELECT_TAB, tab, id})

export const setSelectedContactTab = (tab) => ({type: types.NAVIGATION_SET_SELECTED_CONTACT_TAB, tab})
export const setSelectedQuotingTab = (tab) => ({type: types.NAVIGATION_SET_SELECTED_QUOTING_TAB, tab})
export const setSelectedPurchasingTab = (tab) => ({type: types.NAVIGATION_SET_SELECTED_PURCHASING_TAB, tab})
